const parseURL = url => {
  const newUrl = new URL(url);
  let type = '';
  let id = '';
  let path = '';
  let newId = '';

  url.match(
    /(http:|https:|)\/\/(player.|www.|m.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/,
  );

  if (RegExp.$3.indexOf('youtu') > -1) {
    type = 'youtube';
    id = RegExp.$6;
  } else if (
    RegExp.$3.indexOf('vimeo') > -1 &&
    newUrl.pathname.indexOf('channels') > -1
  ) {
    path = newUrl.pathname.split('/');
    newId = path[3];
    type = 'vimeo';
    id = newId;
  } else if (RegExp.$3.indexOf('vimeo') > -1) {
    type = 'vimeo';
    id = RegExp.$6;
  }

  return {
    type,
    id,
  };
};

export { parseURL };
